import { MainList } from '@/pages/ListContentPage/MainList';
import { RouteWrapper } from '@/pages/ListContentPage/RouteWrapper';

export const ContentPageNewDesign = () => {
  return (
    <RouteWrapper>
      <MainList />
    </RouteWrapper>
  );
};

export default ContentPageNewDesign;
